import { render, staticRenderFns } from "./tipoelemento.vue?vue&type=template&id=420fac78"
import script from "./tipoelemento.vue?vue&type=script&lang=js"
export * from "./tipoelemento.vue?vue&type=script&lang=js"
import style0 from "./tipoelemento.vue?vue&type=style&index=0&id=420fac78&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports